/**
 * An hours slider with its current value spelled out beside the label --
 * shared by the "Starts in" (0-24h, "Now" at 0) and "Total duration" (1-48h)
 * controls on the Create/Edit trip modals. Mirrors the Android app's
 * StartsInSlider/TotalDurationSlider.
 *
 * @param {string} label
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @param {(value: number) => void} onChange
 * @param {(value: number) => string} [formatValue] - Defaults to "N hour(s)"
 */
export default function CheckerHoursSlider({
    label,
    value,
    min,
    max,
    onChange,
    formatValue = (hours) => `${hours} hour${hours === 1 ? "" : "s"}`,
}) {
    return (
        <div className="checker-slider-group">
            <div className="checker-slider-header">
                <span className="checker-slider-label">{label}</span>
                <span className="checker-slider-value">{formatValue(value)}</span>
            </div>
            <input
                type="range"
                className="form-range"
                min={min}
                max={max}
                step={1}
                value={value}
                onChange={(event) => onChange(Number(event.target.value))}
            />
        </div>
    )
}
